module.exports = __webpack_public_path__ + "img/nop-icon.4a8bd95b.svg";